import pathParser from "./pathParser";
import merge from "deepmerge";

const dataNormalizer = data => {
  let path, mergeOb;

  const merged = data.points.reduce((map, i) => {
    path = pathParser(i.Path);
    mergeOb = {
      [path[2]]: {
        [path[3]]: {
          value: i.Value,
          units: i.Units ? "°F" : "",
          displayName: i.DisplayName
        }
      }
    };

    map = merge(map, mergeOb);
    return map;
  }, {});

  return merged;
};

export default dataNormalizer;



// WEBPACK FOOTER //
// ./src/pages/util/dataNormalizer.js